import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import siteConfig from '@iso/config/site.config';
import { notification } from '@iso/components';

const gaxios = require('gaxios');

// Configuración de gaxios
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
  headers: {
    Authorization: localStorage.getItem('access_token')
  }
};

// ============ API CALLS ============

/**
 * Obtiene estadísticas de ventas
 * @param {Object} params - { inicio, fin, periodo }
 */
function* fetchEstadisticasVentas(params) {
  const { inicio, fin, periodo = 'diario' } = params;
  const queryParams = new URLSearchParams({ inicio, fin, periodo }).toString();
  
  const response = yield call(gaxios.request, {
    url: `api/estadisticas/ventas?${queryParams}`,
    method: 'GET',
  });
  
  return response.data;
}

/**
 * Obtiene estadísticas de ingresos
 * @param {Object} params - { inicio, fin, periodo }
 */
function* fetchEstadisticasIngresos(params) {
  const { inicio, fin, periodo = 'semanal' } = params;
  const queryParams = new URLSearchParams({ inicio, fin, periodo }).toString();
  
  const response = yield call(gaxios.request, {
    url: `api/estadisticas/ingresos?${queryParams}`,
    method: 'GET',
  });
  
  return response.data;
}

/**
 * Obtiene estadísticas de egresos
 * @param {Object} params - { inicio, fin, periodo }
 */
function* fetchEstadisticasEgresos(params) {
  const { inicio, fin, periodo = 'anual' } = params;
  const queryParams = new URLSearchParams({ inicio, fin, periodo }).toString();
  
  const response = yield call(gaxios.request, {
    url: `api/estadisticas/egresos?${queryParams}`,
    method: 'GET',
  });
  
  return response.data;
}

// ============ SAGAS ============

/**
 * Saga para obtener estadísticas de ventas
 */
function* getEstadisticasVentas(action) {
  try {
    const data = yield call(fetchEstadisticasVentas, action.payload);
    
    if (data.success) {
      yield put(actions.getEstadisticasVentasSuccess(data.estadisticas || data));
      
      notification('success', {
        message: 'Estadísticas de ventas obtenidas correctamente',
      });
    } else {
      throw new Error(data.message || 'Error al obtener estadísticas de ventas');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Error al obtener estadísticas de ventas';
    
    yield put(actions.getEstadisticasVentasError(errorMessage));
    
    notification('error', {
      message: 'Error',
      description: errorMessage,
    });
  }
}

/**
 * Saga para obtener estadísticas de ingresos
 */
function* getEstadisticasIngresos(action) {
  try {
    const data = yield call(fetchEstadisticasIngresos, action.payload);
    
    if (data.success) {
      yield put(actions.getEstadisticasIngresosSuccess(data.estadisticas || data));
      
      notification('success', {
        message: 'Estadísticas de ingresos obtenidas correctamente',
      });
    } else {
      throw new Error(data.message || 'Error al obtener estadísticas de ingresos');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Error al obtener estadísticas de ingresos';
    
    yield put(actions.getEstadisticasIngresosError(errorMessage));
    
    notification('error', {
      message: 'Error',
      description: errorMessage,
    });
  }
}

/**
 * Saga para obtener estadísticas de egresos
 */
function* getEstadisticasEgresos(action) {
  try {
    const data = yield call(fetchEstadisticasEgresos, action.payload);
    
    if (data.success) {
      yield put(actions.getEstadisticasEgresosSuccess(data.estadisticas || data));
      
      notification('success', {
        message: 'Estadísticas de egresos obtenidas correctamente',
      });
    } else {
      throw new Error(data.message || 'Error al obtener estadísticas de egresos');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Error al obtener estadísticas de egresos';
    
    yield put(actions.getEstadisticasEgresosError(errorMessage));
    
    notification('error', {
      message: 'Error',
      description: errorMessage,
    });
  }
}

// ============ WATCHERS ============

export default function* estadisticasSaga() {
  yield all([
    takeEvery(actions.GET_ESTADISTICAS_VENTAS, getEstadisticasVentas),
    takeEvery(actions.GET_ESTADISTICAS_INGRESOS, getEstadisticasIngresos),
    takeEvery(actions.GET_ESTADISTICAS_EGRESOS, getEstadisticasEgresos),
  ]);
}
